export const initialLeads = [
  {
    id: "lead-101",
    name: "Alexander Wright",
    company: "Nexus Logistics Corp",
    email: "a.wright@nexuslogistics.io",
    phone: "+1 (415) 892-3104",
    country: "United States",
    service: "AI Development",
    budget: "$25,000+",
    timeline: "1–3 Months",
    projectDetails: "Need a custom AI demand forecasting platform with automated purchase order dispatch and ERP webhook integration for 30 warehouses.",
    source: "Start a Project Wizard",
    assignedTo: "Alex Thorne",
    status: "Negotiation",
    createdDate: "2026-08-28T14:30:00Z",
    activities: [
      { id: "act-1", type: "Lead Created", note: "Lead submitted via multi-step wizard", timestamp: "2026-08-28T14:30:00Z" },
      { id: "act-2", type: "Meeting Scheduled", note: "30-min discovery call conducted with CTO", timestamp: "2026-08-29T16:00:00Z" },
      { id: "act-3", type: "Proposal Sent", note: "Architecture spec and sprint breakdown PDF delivered", timestamp: "2026-08-30T11:00:00Z" },
      { id: "act-4", type: "Status Changed", note: "Moved to Negotiation phase", timestamp: "2026-08-31T09:00:00Z" }
    ]
  },
  {
    id: "lead-102",
    name: "Sophie Tremblay",
    company: "Clinique Health Systems",
    email: "sophie@cliniquenet.ca",
    phone: "+1 (514) 778-9012",
    country: "Canada",
    service: "Web Development",
    budget: "$10,000–$25,000",
    timeline: "3–6 Months",
    projectDetails: "Rebuilding our patient appointment and doctor consultation portal with HIPAA compliance and bilingual French/English support.",
    source: "Contact Page",
    assignedTo: "Marcus Sterling",
    status: "Proposal Sent",
    createdDate: "2026-08-29T10:15:00Z",
    activities: [
      { id: "act-1", type: "Lead Created", note: "Contact form inquiry received", timestamp: "2026-08-29T10:15:00Z" },
      { id: "act-2", type: "Email Sent", note: "Introductory email with healthcare case study sent", timestamp: "2026-08-29T12:00:00Z" },
      { id: "act-3", type: "Proposal Sent", note: "Technical proposal with WebRTC specs delivered", timestamp: "2026-08-30T18:00:00Z" }
    ]
  },
  {
    id: "lead-103",
    name: "Liam O'Connor",
    company: "Veloce Payments Ltd",
    email: "liam@velocepay.co.uk",
    phone: "+44 20 7946 0912",
    country: "United Kingdom",
    service: "Custom Software",
    budget: "$25,000+",
    timeline: "ASAP",
    projectDetails: "High-security corporate ledger and settlement engine with multi-currency banking rails and automated compliance reporting.",
    source: "Referral / Direct",
    assignedTo: "Alex Thorne",
    status: "Won",
    createdDate: "2026-08-20T09:00:00Z",
    activities: [
      { id: "act-1", type: "Lead Created", note: "Inbound client referral", timestamp: "2026-08-20T09:00:00Z" },
      { id: "act-2", type: "Status Changed", note: "Master Services Agreement (MSA) signed. Initial deposit paid.", timestamp: "2026-08-27T15:00:00Z" }
    ]
  },
  {
    id: "lead-104",
    name: "Tariq Al-Mansoor",
    company: "Sahara Retail Ventures",
    email: "tariq@sahararetail.ae",
    phone: "+971 4 391 0000",
    country: "United Arab Emirates",
    service: "E-Commerce",
    budget: "$10,000–$25,000",
    timeline: "1–3 Months",
    projectDetails: "Headless Shopify storefront with Arabic RTL support, regional payment gateways (Tabby/Tamara), and ERP sync.",
    source: "Start a Project Wizard",
    assignedTo: "Marcus Sterling",
    status: "Qualified",
    createdDate: "2026-08-30T18:45:00Z",
    activities: [
      { id: "act-1", type: "Lead Created", note: "Wizard inquiry received", timestamp: "2026-08-30T18:45:00Z" },
      { id: "act-2", type: "Status Changed", note: "Qualified budget and tech feasibility verified", timestamp: "2026-08-31T08:00:00Z" }
    ]
  },
  {
    id: "lead-105",
    name: "Dr. Ethan Brooks",
    company: "BioVanguard Analytics",
    email: "ebrooks@biovanguard.org",
    phone: "+1 (617) 555-0192",
    country: "United States",
    service: "AI Development",
    budget: "$25,000+",
    timeline: "3–6 Months",
    projectDetails: "Biomedical research paper retrieval engine using private RAG, vector embeddings over PubMed literature, and automated summarization.",
    source: "Project Estimator",
    assignedTo: "Dr. Sofia Chen",
    status: "New",
    createdDate: "2026-08-31T11:20:00Z",
    activities: [
      { id: "act-1", type: "Lead Created", note: "Submitted via interactive Project Cost Estimator", timestamp: "2026-08-31T11:20:00Z" }
    ]
  }
];
